export function DateDisplay(date) {

    let displayDate = new Date(date);
    let newDisplayDate = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        year: 'numeric',
        timeZone: 'utc'
    }).format(displayDate);
    
    return newDisplayDate;
  }

  export function FullDate(date){
      let displayDate = new Date(date);
      let newDisplayDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'utc'
        }).format(displayDate);
        
      return newDisplayDate
  }
